var $6e27fca25410d501$exports = {};
$6e27fca25410d501$exports = {
    "info": `Oplysninger`,
    "negative": `Fejl`,
    "notice": `Advarsel`,
    "positive": `Fuldf\xf8rt`
};


export {$6e27fca25410d501$exports as default};
//# sourceMappingURL=da-DK.mjs.map
